import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { publicApi } from "../lib/api";

// Global provider for:
//  1. `company` — the single source of truth for company contact info,
//     served from /api/public/content.company_contact. Consumed by the
//     Contact Page, Contact Modal, Footer, About Page, and any future
//     surface that needs the business's phone/email/whatsapp/address/etc.
//  2. `openContactModal` — used by Hero + Sticky Bar + Mobile Menu to
//     replace the old "scroll to footer" Get In Touch behaviour.
const CompanyCtx = createContext({
  company: null,
  content: null,
  isOpen: false,
  openContactModal: () => {},
  closeContactModal: () => {},
  refresh: () => {},
});

export const CompanyProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const refresh = useCallback(() => {
    publicApi.content().then(setContent).catch(() => setContent(null));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const openContactModal = useCallback(() => setIsOpen(true), []);
  const closeContactModal = useCallback(() => setIsOpen(false), []);

  const company = content?.company_contact || null;

  return (
    <CompanyCtx.Provider value={{ company, content, isOpen, openContactModal, closeContactModal, refresh }}>
      {children}
    </CompanyCtx.Provider>
  );
};

export const useCompany = () => useContext(CompanyCtx);
